import axios from 'axios';
import { SavedStateKey } from '../constants/localStorageKeys';

const createBackendAxios = (onPrivateSaleInactive, onSaleActive, onSaleStarts, onSaleFinished) => {
  const backendAxios = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
  });

  backendAxios.interceptors.response.use(
    (response) => {
      const storedData = localStorage.getItem(SavedStateKey);
      const combinedData = storedData ? JSON.parse(storedData) : {};
      const actualPageNumber = combinedData.pageNumber;
      if ((!storedData || actualPageNumber === 500 || actualPageNumber === 501 || actualPageNumber === 502) && response.config.url === "/script/stats"){
        onSaleActive();
        window.location.reload();
      }

      return response;
    },
    (error) => {
      try {
        const storedData = localStorage.getItem(SavedStateKey);
        const combinedData = storedData ? JSON.parse(storedData) : {};
        const actualPageNumber = combinedData.pageNumber;

        if (!actualPageNumber || actualPageNumber < 3 || actualPageNumber > 5) {
          switch (error.response.data.saleStatus) {
            case 'START':
              onSaleStarts();
              break;            
            case 'OVER':
              onSaleFinished();
              break;
            case 'PUBLIC_SALE_SOON':
              onPrivateSaleInactive();
              break;      
          }
        }
      }
      catch {}
      throw error;
    }
  );

  return backendAxios;
};

export default createBackendAxios;